import { useQuery } from "@bb-vendure/admin-ui/react";
import { gql } from "graphql-tag";

const FETCH_SPEC_BY_VAR_ID = gql`
  query FetchSpecByVarId($id: ID!) {
    getSpecsByProductVariantId(productVariantId: $id) {
      value
      name
      id
      createdAt
      updatedAt
    }
  }
`;

export const useFetchSpecByVarId = <T>(id: string) => {
  return useQuery<T>(FETCH_SPEC_BY_VAR_ID, { id });
};
